import React from 'react'
import { useTranslation } from 'react-i18next'
import KPIImpactsSection from './KPI/KpiImpacts'
import AverageMetric from './KPI/AverageMetric'
import AverageVolumePerConsumer from './KPI/AverageVolumePerConsumer'
import { EXPERIMENT_TYPES } from '../../../../_common/constant'

interface Props {
    experimentDetails: any
    selectedGroup: string | null
    selectedKPI: any
    selectedDateRange: any[]
    selectedOption?: string | null
    toDownloadAsReport?: boolean
    reportError?: (x: boolean) => void
    setKpiImpactsData: (data: any[]) => void
}
const ExperimentInsightsSection: React.FC<Props> = ({ setKpiImpactsData, experimentDetails, selectedGroup, selectedKPI, selectedDateRange, selectedOption, toDownloadAsReport = false, reportError }) => {
    const { t } = useTranslation()
    const conversionMetric: any = experimentDetails?.experiment_metadatas?.metrices.filter((metric: any) => metric.literral_value === 'Incremental Conversion') ?? []
    const gridCols = conversionMetric.length > 0 ? 'grid-cols-2' : 'grid-cols-3'
    const experimentTypeTitle = experimentDetails?.experiment_type?.title
    const isPostTreatmentExperiment = experimentTypeTitle === 'Post-Treatment Comparison'
    const gridColsClass = isPostTreatmentExperiment ? 'grid-cols-1' : gridCols

    return (
        <div data-testid="experiment-insights-section" className={`grid ${gridColsClass} gap-3`} aria-label={t('Experiment Insights Section')}>
            {(experimentTypeTitle == EXPERIMENT_TYPES.RCT.title || experimentTypeTitle == EXPERIMENT_TYPES.OBS.title || isPostTreatmentExperiment) && selectedOption ? (
                <KPIImpactsSection
                    experimentDetails={experimentDetails}
                    selectedKPI={selectedKPI}
                    selectedGroup={selectedGroup}
                    selectedDateRange={selectedDateRange}
                    selectedOptionConfig={selectedOption}
                    toDownloadAsReport={toDownloadAsReport}
                    reportError={reportError}
                    setKpiImpactsData={setKpiImpactsData}
                />
            ) : (
                <></>
            )}

            {!isPostTreatmentExperiment &&
                (conversionMetric.length > 0 ? (
                    <></>
                ) : (
                    <AverageVolumePerConsumer
                        experimentDetails={experimentDetails}
                        selectedGroup={selectedGroup}
                        selectedKPI={selectedKPI?.value || null}
                        selectedDateRange={selectedDateRange}
                        selectedOptionConfig={selectedOption}
                        toDownloadAsReport={toDownloadAsReport}
                        mtegrouptext={null}
                        reportError={reportError}
                    />
                ))}

            <AverageMetric
                experimentDetails={experimentDetails}
                selectedGroup={selectedGroup}
                selectedKPI={selectedKPI?.value || null}
                selectedDateRange={selectedDateRange}
                selectedOptionConfig={selectedOption}
                toDownloadAsReport={toDownloadAsReport}
                reportError={reportError}
            />
        </div>
    )
}
export default ExperimentInsightsSection
